import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default async function getProduct(itemNo: string | undefined) {
    if (!itemNo) {
        return Promise.reject(new Error(shopErrors.invalidProductItemNumber.message));
    }

    return shop
        .get(getUrl(`/products/get/${itemNo}`), {
            hooks: {
                afterResponse: [
                    async (_request, _options, response) => {
                        if (response.status === 404) {
                            const body = await response.arrayBuffer();
                            return new Response(body, {
                                status: 200,
                                statusText: response.statusText,
                                headers: response.headers,
                            });
                        }

                        return response;
                    },
                ],
            },
        })
        .json<ShopTypes.ProductQueryResult & ShopTypes.ApiExceptionResponse>();
}
